import React from 'react';


const UserProfilePage = () => {
    return (
        <>

        </>
    );
};

export default UserProfilePage;
